import React, { forwardRef } from "react";
import { Flex } from "../../../primitives/Flex/Flex";
import { FlexRowBaseProps, FlexRowComponent } from "./FlexRow.types";

/**
 * FlexRow component - A horizontal flex layout (flex with direction="row")
 *
 * @example
 * // Basic usage
 * <FlexRow gap="medium" align="center">
 *   <Box>Left content</Box>
 *   <Box>Right content</Box>
 * </FlexRow>
 *
 * // As a header
 * <FlexRow as="header" justify="space-between">
 *   <Box>Logo</Box>
 *   <Box>Navigation</Box>
 * </FlexRow>
 */

export const FlexRow = forwardRef(function FlexRow(
  props: FlexRowBaseProps & { as?: React.ElementType },
  ref
) {
  const { as, ...rest } = props;

  return (
    <Flex
      ref={ref}
      as={as}
      flexDirection="row"
      alignItems="center"
      width="100%"
      {...(rest as Record<string, unknown>)}
    />
  );
}) as FlexRowComponent;

// Set display name for debugging
FlexRow.displayName = "FlexRow";

export default FlexRow;
